import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-yarn-twist',
  templateUrl: './yarn-twist.component.html',
  styleUrls: ['./yarn-twist.component.css']
})
export class YarnTwistComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
